import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { DatePipe } from '@angular/common';
import { NoPreloading, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { routes } from './app/app-routing.module';
import { HttpInterceptorService } from './app/services/core/http/http-interceptor.service';
import { PaymentDeeplinksService } from './app/services/payment-deeplinks/payment-deeplinks.service';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Storage } from '@ionic/storage';
import { provideGoogleTagManager } from 'angular-google-tag-manager';
import { provideScReCaptchaSettings } from '@semantic-components/re-captcha';
import 'add-to-calendar-button';
export function createTranslateLoader(http: HttpClient) {
  // return new TranslateHttpLoader(http, `${environment?.s3_base_url}content/dam/tlc/${environment?.programName?.toLowerCase().replace(/\s+/g, "-")}/`, '.json',);
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
import { addIcons } from 'ionicons';
import { chevronForwardOutline } from 'ionicons/icons';

// Register Ionicons globally
addIcons({
  'chevron-forward-outline': chevronForwardOutline,
});
if (environment.production) {
  enableProdMode();
}
registerSwiperElements(); // Register Swiper custom elements

bootstrapApplication(AppComponent, {
  providers: [
    provideIonicAngular({ innerHTMLTemplatesEnabled: true, mode: "ios" }), 
    DatePipe,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    provideRouter(routes, withPreloading(NoPreloading)),  
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    PaymentDeeplinksService,
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    Storage,
    provideGoogleTagManager({
      id: "GTM-K2CMCTKS"
    }),
    provideScReCaptchaSettings({
      languageCode: "en",
      v2SiteKey: environment.RECAPTCHA_SITE_KEY
    })
  ]
})
